import { t } from '@framework/i18n';
import {
  SearchableField,
  SearchableFieldGroup,
  SearchableFieldType,
} from '@framework/ui';

export const AddressBookSearchableFields: SearchableField[] = [
  {
    type: SearchableFieldType.Text,
    label: t(
      'address-book.searchable-fields.identificativo-label',
      'Identificativo',
    ),
    name: 'primarySearchField',
    placeholder: t(
      'address-book.searchable-fields.identificativo-placeholder',
      'CF/E-Mail...',
    ),
    group: SearchableFieldGroup.Filters,
  },
  {
    type: SearchableFieldType.Text,
    label: t(
      'address-book.searchable-fields.ricerca-altri-campi-label',
      'Ricerca per altri campi',
    ),
    name: 'secondarySearchField',
    placeholder: t(
      'address-book.searchable-fields.ricerca-altri-campi-placeholder',
      'Nome, cognome, indirizzo...',
    ),
    group: SearchableFieldGroup.Filters,
  },
];
